<div *ngIf="recaptcha">
    <re-captcha
        (resolved)="resolved($event)"
        [siteKey]="recaptcha"
    ></re-captcha>
</div>
